<!--
    编辑器备注组件
    作用：课件备注，在COCOS组件中；
    实现：编辑备注信息用；
    组件：无
    注释：WJ
-->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="close"
    :append-to-body="true"
    :close-on-click-modal="false"
    title="备注"
    width="532px">
    <textarea class="textarea" v-model="curValue" placeholder="请输入备注" />
<!--    <AppTextArea-->
<!--      v-if="visible"-->
<!--      :value.sync="htmlContent"-->
<!--      :is-disable="false"-->
<!--      @change="change"-->
<!--    />-->
    <span
      slot="footer"
      class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button
        type="primary"
        @click="handleSend">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import AppTextArea from './components/AppTextArea';

export default {
  name: 'EditContent',
  components: {
    // AppTextArea,
  },
  props: {
    value: Object,
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogVisible(vl) {
      this.$emit('update:visible', vl);
    },
    visible(vl) {
      this.dialogVisible = vl;
    },
    value:{
      handler(vl) {
        // this.htmlContent = vl
        if (vl.value) this.curValue = vl.value
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      htmlContent: this.value, // 富文本内容
      curValue: ''
    };
  },
  methods: {
    change(html) {
      this.htmlContent = html;
    },
    close(){
      this.dialogVisible = false
    },
    handleSend(){
      this.$emit('onEditContent', {value: this.curValue, type: 'word'})
      this.close()
    }
  },
};
</script>

<style lang="scss" scoped>
.textarea{
  width: calc(100% - 40px);
  height: 120px;
  padding: 20px;
  font-size: 16px;
  outline: none;
  resize: none;
  border: 1px solid #D8DCE6;
  background: #FFFFFF;
  border-radius: 4px;
}
</style>
